// Function to remove all title tags
function removeAllTitleTags() {
  const titleTags = document.querySelectorAll('title');
  titleTags.forEach(tag => tag.remove()); // Loop through and remove each tag
}

// Call the function to remove all title tags
removeAllTitleTags();

